var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2 } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationStatus } from '../enums/enums';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
var AuthPermanentPasswordComponent = /** @class */ (function (_super) {
    __extends(AuthPermanentPasswordComponent, _super);
    function AuthPermanentPasswordComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.showCaptcha = false;
        _this._countTimes = 0;
        _this._captchaResponse = null;
        _this._captchaReady = false;
        return _this;
    }
    AuthPermanentPasswordComponent.prototype.ngOnInit = function () {
        var element = this.renderer.selectRootElement('#pPassword');
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2108' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2108 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "סיסמה קבועה");
        sessionStorage.setItem("elasticCode", "2188");
    };
    AuthPermanentPasswordComponent.prototype.captchaSuccess = function (captchaResponse) {
        this._captchaResponse = captchaResponse;
        this.callServer();
    };
    AuthPermanentPasswordComponent.prototype.captchaReady = function () {
        this._captchaReady = true;
    };
    AuthPermanentPasswordComponent.prototype.submit = function (form) {
        this._form = form;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            if (this._captchaReady) {
                this.captchaElem.execute();
            }
            else {
                this.callServer();
            }
        }
        this.buildFormAccessibility();
    };
    AuthPermanentPasswordComponent.prototype.callServer = function () {
        var _this = this;
        this.authUserService.sendAuthData("ValidatePassword", { Password: this._form.value.pPassword, captchaResponse: this._captchaResponse })
            .subscribe(function (res) {
            if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidPassword") {
                _this.serverError = "הסיסמה אינה תקינה";
                if (_this.captchaElem != null && _this.showCaptcha) {
                    _this.captchaElem.resetCaptcha();
                }
                if (_this._countTimes == 8) {
                    _this.showCaptcha = true;
                }
                else {
                    _this._countTimes++;
                }
                var elements_1 = _this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; });
                if (elements_1 && elements_1.length > 0) {
                    elements_1[0].setAttribute('aria-invalid', true);
                    setTimeout(function () { return elements_1[0].focus(); }, 0);
                }
            }
            else if (res.Details.UserInputError == "ReCaptchaInvalid") {
                _this.captchaElem.resetCaptcha();
                _this.serverError = "הקאפצ'ה נכשלה";
            }
            else {
                _this.modalService.close(res.Details);
            }
        }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
    };
    return AuthPermanentPasswordComponent;
}(AuthBaseComponent));
export { AuthPermanentPasswordComponent };
